import React from "react"
import { IIconProps } from "./Icon/Interfaces"

const ArrowRightEnd = ({ width = 21, height = 22, strokeColor = "var(--blue)" }: IIconProps) => {
	return (
		<svg
			className="flip-horizontal"
			width={width}
			height={height}
			viewBox="0 0 7 12"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect x="-2" y="1" width="1.5" height={10} rx="0.75" fill="#267CE7" />

			<mask
				id="path-1-outside-1"
				maskUnits="userSpaceOnUse"
				x="0.5"
				y="-2.62268e-07"
				width="7"
				height="12"
				fill="black"
			>
				<rect fill="white" x="0.5" y="-2.62268e-07" width="7" height="12" />
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M3.0496 5.38287C2.73347 5.69384 2.73347 6.30616 3.0496 6.61713L6.5 10.0112L6.5 10.2216C6.5 10.8653 5.92636 11.2298 5.52884 10.8388L1.2371 6.61713C0.920965 6.30615 0.920965 5.69384 1.2371 5.38287L5.52884 1.16125C5.92636 0.770224 6.5 1.13475 6.5 1.77837L6.5 1.98884L3.0496 5.38287Z"
				/>
			</mask>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.0496 5.38287C2.73347 5.69384 2.73347 6.30616 3.0496 6.61713L6.5 10.0112L6.5 10.2216C6.5 10.8653 5.92636 11.2298 5.52884 10.8388L1.2371 6.61713C0.920965 6.30615 0.920965 5.69384 1.2371 5.38287L5.52884 1.16125C5.92636 0.770224 6.5 1.13475 6.5 1.77837L6.5 1.98884L3.0496 5.38287Z"
				fill={strokeColor}
			/>
			<path
				d="M3.0496 6.61713L3.18986 6.47455L3.18986 6.47455L3.0496 6.61713ZM3.0496 5.38287L2.90935 5.24029L2.90935 5.24029L3.0496 5.38287ZM6.5 10.0112L6.7 10.0112L6.7 9.92735L6.64025 9.86858L6.5 10.0112ZM5.52884 10.8388L5.38859 10.9813L5.52884 10.8388ZM1.2371 6.61713L1.37736 6.47455L1.37735 6.47455L1.2371 6.61713ZM1.2371 5.38287L1.09685 5.24029L1.09685 5.24029L1.2371 5.38287ZM5.52884 1.16125L5.66909 1.30383L5.52884 1.16125ZM6.5 1.98884L6.64025 2.13142L6.7 2.07265L6.7 1.98884L6.5 1.98884ZM3.18986 6.47455C3.07785 6.36437 3.0125 6.18931 3.0125 6C3.0125 5.81069 3.07785 5.63563 3.18986 5.52545L2.90935 5.24029C2.70522 5.44109 2.6125 5.72766 2.6125 6C2.6125 6.27234 2.70522 6.55891 2.90935 6.75971L3.18986 6.47455ZM6.64025 9.86858L3.18986 6.47455L2.90935 6.75971L6.35975 10.1537L6.64025 9.86858ZM6.3 10.0112L6.3 10.2216L6.7 10.2216L6.7 10.0112L6.3 10.0112ZM6.3 10.2216C6.3 10.4857 6.18312 10.6687 6.05622 10.7494C5.93943 10.8236 5.79962 10.8246 5.66909 10.6962L5.38859 10.9813C5.65558 11.244 6.00135 11.2582 6.27075 11.087C6.53006 10.9222 6.7 10.6012 6.7 10.2216L6.3 10.2216ZM5.66909 10.6962L1.37736 6.47455L1.09685 6.75971L5.38859 10.9813L5.66909 10.6962ZM1.37735 6.47455C1.26535 6.36437 1.2 6.18931 1.2 6C1.2 5.81069 1.26535 5.63563 1.37735 5.52545L1.09685 5.24029C0.89272 5.44109 0.8 5.72766 0.799999 6C0.8 6.27234 0.89272 6.55891 1.09685 6.75971L1.37735 6.47455ZM1.37735 5.52545L5.66909 1.30383L5.38859 1.01867L1.09685 5.24029L1.37735 5.52545ZM5.66909 1.30383C5.79962 1.17544 5.93943 1.1764 6.05622 1.25062C6.18312 1.33125 6.3 1.51433 6.3 1.77837L6.7 1.77837C6.7 1.39879 6.53006 1.07779 6.27076 0.913015C6.00135 0.741818 5.65558 0.756036 5.38859 1.01867L5.66909 1.30383ZM6.3 1.77837L6.3 1.98884L6.7 1.98884L6.7 1.77837L6.3 1.77837ZM3.18986 5.52545L6.64025 2.13142L6.35975 1.84626L2.90935 5.24029L3.18986 5.52545Z"
				fill={strokeColor}
				mask="url(#path-1-outside-1)"
			/>
		</svg>
	)
}

export default ArrowRightEnd
